import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { tags, useVisualHtmlEditorContext } from "./VisualHtmlEditor";
import { ElementAttr } from "./ElementAttr";
import { ArrayElement } from "./ArrayElement";
import { emptyArray } from "../../../../redux/utils";
import { useDrag } from "react-dnd";
import { IoTrashOutline } from "react-icons/io5";

export const HtmlElement = ({path, element}) => {

  const [tagEdit, setTagEdit] = useState(false);
  const [tag, setTag] = useState(element?.tag);
  const { changeTagElement, removeElement } = useVisualHtmlEditorContext();
  const tagInput = useRef();

  const [{isDragging}, drag] = useDrag(() => ({
    type: 'HTML_MOVE_ELEMENT' ,
    item: element,
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [element])


  const config = useMemo(()=>{
    return tags[tag];
  }, [tag]);

  useEffect(()=>{
    //console.log("HtmlElement", {element, path})
  }, [])

  const handleTagClick = useCallback((event) => {
    setTagEdit(value => true);
  }, []);

  const handleRemoveClick = useCallback(() => {
    removeElement(path);
  }, [removeElement, path]);

  useEffect(()=>{
    if(tagEdit){
      if (tagInput.current) {
        tagInput.current.focus();
        tagInput.current.select();
      }
    }
  }, [tagEdit]);

  const handleTagChange = useCallback((event) => {
    setTag(value => event.target.value);
  }, []);

  const handleTagKeyDown = useCallback((event) => {
    var key = event.keyCode || event.which;
    if (key === 13) {
      setTagEdit(value => false);
      changeTagElement(tag, path);
    }
    if (event.key === "Escape") {
      setTagEdit(value => false);
      setTag(element?.tag);      
    }
  }, [tag, path, element?.tag, changeTagElement]);

  const handleTagBlur = useCallback((event) => {
      setTagEdit(value => false);
      changeTagElement(tag, path);
  }, [tag, path, changeTagElement]);

  const attribs = useMemo(()=>{
    return element.attr && Object.keys(element.attr).reduce((values, key) => {
      return [
        ...values,
        <ElementAttr config={config?.attribs} key={key} path={path} name={key} value={typeof element.attr[key] === "string" ? element.attr[key] : element.attr[key].join(" ")} />
      ];
    }, []);
  }, [config, element.attr, path]);


  const iniTag = useMemo(() => <>
      {"<"}
      {element?.tag 
        ? (tagEdit 
            ? <input ref={tagInput} type="text" value={tag} onChange={handleTagChange} onKeyDown={handleTagKeyDown} onBlur={handleTagBlur}/> 
            : <span className="vhe-tag-name" ref={drag} onClick={handleTagClick}>{element.tag}</span>
          )
        : "root"
      }        
      {attribs && attribs.length > 0 &&
        attribs
      }
  </>, [attribs, tagEdit, element?.tag, tag, handleTagChange, handleTagKeyDown, handleTagBlur, handleTagClick]);

  const htmlElement = useMemo(() => {
    if(config?.acceptElements !== false || config?.acceptText !== false){
      return <>
        <div className="vhe-html-element-tag1">
          {iniTag}
          {">"}
          {element?.tag &&
            <span className="vhe-html-element-remove" onClick={handleRemoveClick}>
              <IoTrashOutline style={{marginLeft: 4, width: 14, minWidth: 14, height: 14, cursor: "pointer"}} color="#a80303" />
            </span>      
          }
        </div>
        <div className="vhe-html-element-array">
          <ArrayElement acceptElements={config?.acceptElements} acceptText={config?.acceptText} arr={element?.child || emptyArray} path={`${path}${path && "."}child`}></ArrayElement>
        </div>
        <div className="vhe-html-element-tag2">
          {"</"}<span className="vhe-tag-name">{element.tag}</span>{">"}
        </div>
      </>
    }
    else if(config?.acceptElements === false && config?.acceptText === false){ 
      return <div className="vhe-html-element-tag1"> 
        {iniTag}
        {"/>"}
        {element?.tag &&
          <span className="vhe-html-element-remove" onClick={handleRemoveClick}>
            <IoTrashOutline style={{marginLeft: 4, width: 14, minWidth: 14, height: 14, cursor: "pointer"}} color="#a80303" />
          </span>      
        }
      </div>
    }
  }, [element?.tag, element?.child, path, iniTag, config, handleRemoveClick]);

  return (
    <>
      <div className="vhe-html-element">
        {htmlElement}
      </div>
    </>
  )
}